import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserRoles } from '../../../models/User';

export enum TaskRequestTypeEnum {
  UNDEFINED_PRODUCT = "UNDEFINED_PRODUCT"
}

@Injectable({
  providedIn: 'root'
})
export class TaskRequestSidenavService {
  toggleTaskRequest = new Subject();
  promise;
  resolve;
  private tasksPermissionMap: Map<TaskRequestTypeEnum, UserRoles[]> = new Map([
    [TaskRequestTypeEnum.UNDEFINED_PRODUCT, [UserRoles.MASTER, UserRoles.ADMIN]]
  ]);

  constructor() { }

  toggle(data) {
    this.toggleTaskRequest.next(data);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
    });
  }

  closeSidenav(data) {
    this.resolve(data);
  }

  hasPermission(taskType: TaskRequestTypeEnum, userRole: UserRoles): boolean {
    const allowedRoles = this.tasksPermissionMap.get(taskType);
    return allowedRoles?.includes(userRole) ?? false;
  }
}
